!function($, window, document) {
    const $html = $("html"), $win = $(window), $doc = $(document), $body = $(document.body), players = $(".js-media");
    function window_height() {
        return window.innerHeight;
    }
    function banner_height() {
        let $banner = $(".banner");
        return $banner.length ? $banner.outerHeight() : 0;
    }
    $.event.special.widthResize = {
        setup: function() {
            const $this = $(this);
            $this.data("currentWidth", $this.width()), $this.on("resize.widthResize", (function() {
                const newWidth = $this.width();
                newWidth !== $this.data("currentWidth") && $this.data("currentWidth", newWidth).trigger("widthResize");
            }));
        },
        teardown: function() {
            $(this).off("resize.widthResize");
        }
    };
    function isTouchDevice() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    function setFooterFormSelectSpacings() {
        $(".footer .custom-select-container").each((function() {
            const $this = $(this), bottomOffset = $this.offset().top + $this.outerHeight();
            setCSSVariable("max-height", $doc.outerHeight() - bottomOffset, "px", $this);
        }));
    }
    function setCSSVariable(name, value, unit = "", $element = $html) {
        $element.css(`--${name}`, `${value}${unit}`);
    }
    $(".nav-btn, .js-nav-close").on("click", (function(e) {
        e.preventDefault(), function toggleMenu() {
            $body.toggleClass("menu-open"), $body.removeClass("form-open");
        }();
    })), $doc.on("mouseup", (function(e) {
        const $container = $(".header__nav, .nav-btn, .js-nav-close");
        $container.is(e.target) || 0 !== $container.has(e.target).length || ($body.removeClass("menu-open"), 
        $(".nav-btn").text("Menu"));
    })), $(".js-enquire").on("click", (function(e) {
        "#" == $(this).attr("href") && (e.preventDefault(), function toggleForm() {
            $body.toggleClass("form-open"), $body.removeClass("menu-open");
        }());
    })), $doc.on("mouseup", (function(e) {
        const $container = $(".header__form, .js-enquire");
        $container.is(e.target) || 0 !== $container.has(e.target).length || ($body.removeClass("form-open"), 
        $(".header__btn.js-enquire").text("Enquire"));
    })), ((players, options) => {
        players.each((function() {
            if (!this) return;
            const $currentMedia = $(this).closest(".media"), mediaAutoplay = "click" !== $currentMedia.data("autoplay") && !1 !== $currentMedia.data("autoplay") && "hover" !== $currentMedia.data("autoplay"), player = new Plyr(this, {
                volume: 0,
                autoplay: !1,
                clickToPlay: !1,
                controls: [],
                muted: !0,
                loop: {
                    active: !0
                },
                vimeo: {
                    background: !0
                },
                ...options
            });
            let observer = new IntersectionObserver((entries => {
                entries.map((entry => {
                    entry.isIntersecting && mediaAutoplay && player ? player.play() : player.pause();
                }));
            }), {
                rootMargin: "0px +200px",
                threshold: 0
            });
            $currentMedia[0].plyr = player, player.on("ready", (() => {
                (video => {
                    const player = video[0].plyr;
                    video.data("mute") ? (player.muted = !0, player.volume = 0, player.decreaseVolume(100)) : (player.muted = !1, 
                    player.volume = 1, player.increaseVolume(100));
                })($currentMedia), player.pause(), observer.observe($currentMedia[0]);
            })), player.on("play", (() => {
                $currentMedia.addClass("is-played");
            })), player.on("pause", (() => {
                $currentMedia.removeClass("is-played").find(".js-play-btn").removeClass("is-played");
            }));
        }));
    })(players), setCSSVariable("dvh", .01 * window_height(), "px"), setCSSVariable("current-dvh", .01 * window_height(), "px"), 
    setCSSVariable("header-height", $(".header").outerHeight(), "px"), setCSSVariable("footer-height", $(".footer").outerHeight(), "px"), 
    setCSSVariable("banner-height", banner_height(), "px"), setFooterFormSelectSpacings(), 
    $body.toggleClass("is-touch-device", isTouchDevice()), $win.on("resize scroll", (function() {
        setCSSVariable("current-dvh", .01 * window_height(), "px"), setCSSVariable("footer-height", $(".footer").outerHeight(), "px"), 
        $body.toggleClass("is-touch-device", isTouchDevice());
    })), $win.on("widthResize", (function() {
        setCSSVariable("dvh", .01 * window_height(), "px"), setCSSVariable("header-height", $(".header").outerHeight(), "px"), 
        setCSSVariable("banner-height", banner_height(), "px");
    })), $win.on("resize", (function(e) {
        setFooterFormSelectSpacings();
    })), (() => {
        if ($(".js-section-cover").length < 1) return;
        $body.addClass("cover-visible");
        const $sectionCover = $(".js-section-cover"), hideSection = () => {
            $sectionCover.fadeOut(400, (() => {
                $body.removeClass("cover-visible"), $(".js-fade-up").each((function() {
                    fadeUpObserver.observe(this);
                }));
            }));
        };
        setTimeout(hideSection, 6e3), $sectionCover.on("click wheel touchstart", hideSection);
    })();
    const fadeUpObserver = new IntersectionObserver(((entries, observer) => {
        entries.forEach((entry => {
            entry.isIntersecting && ($(entry.target).addClass("is-visible"), observer.unobserve(entry.target));
        }));
    }), {
        threshold: .1
    });
    $(".js-section-cover").length || $(".js-fade-up").each((function() {
        fadeUpObserver.observe(this);
    }));
    $doc.on("gform_post_render", (() => {
        $("select:visible").customSelect(), setFooterFormSelectSpacings();
    })), $(".header").toggleClass("is-scrolled", $win.scrollTop() > 0), $win.on("scroll resize", (function(e) {
        $(".header").toggleClass("is-scrolled", $win.scrollTop() > 0);
    }));
}(jQuery, window, document);